module.exports = __webpack_public_path__ + "img/36_26.439213cb.png";